// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__2LdRR","disabled":"Checkbox_disabled__1S72Q","checkmark":"Checkbox_checkmark__3dUTp"};